<template>
    <v-container>
      <v-card elevation="1" style="padding: 5px; border-radius: 3px;box-shadow: 2px 2px 16px #e8e8e8">
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            @input="searchContents"
          ></v-text-field>

          <v-menu
            offset-y
            origin="center center"
            class="elelvation-1"
            :nudge-bottom="10"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon flat v-on="on">
                <v-icon class="black--text">more_vert</v-icon>
              </v-btn>
            </template>
            <!-- <v-card class="elevation-0">
              <v-card-text class="pa-0"> -->
            <v-list class="pa-0">
              <v-list-item
                v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                avatar
                to="/bulkholiday"
              >
                <v-list-item-avatar>
                  <v-icon medium dark color="primary">import_export</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-sub-title>Batch import</v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <!-- <v-list-item avatar style="cursor: pointer">
                <v-list-item-avatar>
                  <v-icon medium dark color="primary">cloud_download</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-sub-title>
                    <download-csv :data="holidayExportToCsv" name="HolidayDataCSV.csv"
                      >Export
                    </download-csv>
                  </v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item> -->

              <v-list-item style="cursor: pointer" @click="exportInCSV">
                                <v-list-item-avatar>
                                  <v-icon medium dark color="primary">get_app</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                 
                                    Export
                                </v-list-item-content>
                      </v-list-item>

              <v-divider></v-divider>

              <v-list-item avatar @click="selectAll">
                <v-list-item-avatar>
                  <v-icon medium dark color="primary">check_box</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-sub-title>
                    Select all
                  </v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item
                avatar
                @click="bulkDeleteHolidays"
                v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
              >
                <v-list-item-avatar>
                  <v-icon medium dark color="primary">delete_sweep</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-sub-title>
                    Batch delete
                  </v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item>

              <!-- <v-list-item avatar style="cursor: pointer">
                    <v-list-item-avatar>
                      <v-icon medium dark color="primary">cloud_download</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-sub-title>
                        <download-excel
                                :data   = "holidays"
                                :fields = "holidays_fields"
                                name    = "HolidayDataExcel.xls">
                                Data in excel format
                        </download-excel>
                      </v-list-item-sub-title>
                    </v-list-item-content>
                  </v-list-item> -->
            </v-list>
            <!-- </v-card-text>
            </v-card> -->
          </v-menu>
        </v-toolbar>

      </v-card>

      <v-layout row wrap style="margin: 0px">
        <v-flex xs12 sm12 md12 style="margin-top: 10px; " >
          <div
            v-if="holidayContents.length > 0"
            style="border-radius: 2px; box-shadow: none; padding: 10px"
          >
            <DisplayCard
              v-if="renderComponent"
              :renderData="holidayContents"
              @deleteData="deleteItem"
              @editData="editItem"
              @selectDataIds="BulkDeleteIds"
              :selectAll="selectAllData"
            ></DisplayCard>
          </div>
          <div align="center" v-else>
            <v-nodata
              :loading="loading.holidayOption"
              title
              :networkError="networkError.holidayOption"
              msgDetails="You haven't added any holidays yet"
              icon="noholidays"
              contentBg="lighten-4"
              @retryMethod="getHolidayData"
            ></v-nodata>
          </div>
        </v-flex>
      </v-layout>
      <!-- Add Holiday dialog -->
      <v-dialog v-model="dialog" :fullscreen="$mq == 'mobile' ? true : false" max-width="600px" persistent>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="canSee('modifyHolidays')"
            v-on="on"
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            direction="top"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <v-card elevation="2" style="border-radius: 3px">
          <v-card-title class="primary">
            <h4 class="reg__heading">{{ formTitle }}</h4>
            <v-spacer></v-spacer>
            <v-btn v-if="$mq == 'mobile'"
                icon
                fab
                small
                dark
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text style="padding: 5px 15px">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="editedItem.name"
                  prepend-icon="create"
                  label="Holiday Set Name"
                  ref="holidaySetName"
                  required
                  :rules="holidaySetName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-card elevation="0">
                  <v-card-title style="padding: 5px 10px; font-size: 15px; margin-bottom: -20px">Add Holiday</v-card-title>
                  <v-card-text style="padding: 5px 15px">
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        v-model="holidayName"
                        prepend-icon="create"
                        label="Holiday Name"
                        ref="holidayNameRules"
                        :rules="holidayNameRules"
                      ></v-text-field>
                    </v-flex>

                    <v-flex d-flex xs12 sm12 md12>
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        :return-value.sync="dates"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          
                          <v-combobox
                            v-on="on"
                            v-model="dates"
                            multiple
                            chips
                            small-chips
                            label="Select Date"
                            prepend-icon="date_range"
                          ></v-combobox>

                        </template>
                          
                        <v-date-picker v-model="dates" multiple no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu=false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menu.save(dates)">OK</v-btn>
                        </v-date-picker>

                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm12 md12 class="reg__custom__flex">
                      <v-layout row wrap>
                        <v-flex xs4 sm4 md4 class="reg__custom__flex" style="margin-top: -10px">
                          <v-switch :label="`Half`" v-model="switch2"></v-switch>
                        </v-flex>
                        <v-flex
                          xs5
                          sm6
                          md6
                          class="reg__custom__flex"
                          v-if="switch2"
                          style="margin-top: -15px"
                        >
                          <v-select
                            :items="half"
                            v-model="halfModel"
                            :menu-props="{ maxHeight: '400' }"
                            label="Select Half"
                            item-text="display_name"
                            item-value="value"
                          ></v-select>
                        </v-flex>
                        <v-flex xs3 sm2 md2 class="reg__custom__flex">
                          <v-btn color="blue darken-1" class="white--text" @click="addHoliday"
                            >Add</v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions style="padding: 1px">
                    <v-flex xs12 sm12 md12 style="padding: 5px">
                      <v-card elevation="0" style="margin: 5px; border-left: 7px solid #1976d2" outlined v-for="(item, i) in selectedHolidays" :key="i">
                        <v-card-text style="padding: 5px 20px">
                          <v-layout
                            row
                            wrap
                          >
                            <v-flex xs6 sm6 md6>
                              <h3 style="font-size: 12px !important; text-align: left; margin-top: 0px"> {{item.name}} </h3>
                            </v-flex>

                            <v-flex xs6 sm6 md6>
                              <h3 style="font-size: 12px !important; text-align: right; margin-top: 0px">{{ _.join(item.dates, ",") }}</h3>
                            </v-flex>

                            <v-flex
                              xs6
                              sm6
                              md6
                              v-if="item.halfDayHalf == '1'"
                            >
                              <h3 style="font-size: 12px !important; text-align: left; margin-top: 8px">First half</h3>
                            </v-flex>
                            <v-flex
                              xs6
                              sm6
                              md6
                              v-else-if="item.halfDayHalf == '2'"
                            >
                              <h3 style="font-size: 12px !important; text-align: left; margin-top: 8px">Second half</h3>
                            </v-flex>
                            <v-flex xs6 sm6 md6 v-else >
                              <h3 style="font-size: 12px !important; text-align: left; margin-top: 8px">Full day off</h3>
                            </v-flex>

                            <v-flex xs6 sm6 md6 style="text-align: right">
                              <v-btn @click="removeHoliday(i)" icon ripple><v-icon>delete</v-icon></v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-card-actions>
                </v-card>
              </v-flex>
              
              <h2 style="font-size: 13px; font-weight: 500; color:#1a1a1a; margin-left: 10px">Assigned Members</h2>

              <v-flex v-if="loader" xs12 sm12 md12 class="reg__custom__flex">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-flex>

              <v-flex v-else-if="assignes.length > 0 && formTitle == 'Edit'" xs12 sm12 md12 class="reg__custom__flex" style="text-align: left !important">
                <v-chip
                  v-for="(user, index) in assignes" :key="index"
                  class="ma-2"
                  color="primary"
                  text-color="white"
                  label
                >
                  <v-avatar
                    left
                    color="#fafafa"
                    style="color: #1a1a1a"
                  >
                    {{user.firstName.substring(0,1)}}
                  </v-avatar>
                  {{user.email}}
                </v-chip>
              </v-flex>

              <v-flex v-else-if="formTitle == 'New' || assignes.length < 1 && formTitle == 'Edit'" xs12 sm12 md12 class="reg__custom__flex" style="text-align: left !important">
                <v-alert
                  border="left"
                  colored-border
                  elevation="2"
                  dense
                  color="orange"
                >
                  <h4 style="font-size: 12px; letter-spacing: 0.5px; font-weight: 500; color: #1a1a1a">Currently you dont have any members assigned to this holiday set, please <a href="/#/members">visit</a> the member's page to assign.</h4>
                </v-alert>
              </v-flex>

            </v-layout>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click.native="close">Cancel</v-btn>

            <v-btn v-if="formTitle == 'New'" :disabled="isClicked" :loading="isClicked" color="primary" @click.native="save"
              >Save</v-btn
            >
            <v-btn v-else-if="canSee('modifyHolidays')" :disabled="isClicked" :loading="isClicked" color="primary" @click.native="save"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog
        v-model="preLoader"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-container>
</template>

<script>
import blob from 'blob';
 import Papa from 'papaparse';
import moment from "moment-timezone";
import VNodata from "@/components/Unavailable/nodata.vue";
import canSee from "@/utilities/canSee";
import DisplayCard from "@/views/card.vue"

export default {
  components: { VNodata, DisplayCard },
  data: () => ({
    assignes: [],
    preLoader: false,
    loader: false,
    isClicked: false,
    renderComponent: true,
    selectAllData: false,
    holidayContents: [],
    selectedHolidaysId: [],
    loading: {
      holidayOption: true
    },
    networkError: {
      holidayOption: false
    },
    holidaySetName: [
      v =>
        /^[A-Za-z0-9-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Please enter a valid HolidaySetName"
    ],
    holidayNameRules: [
      v => /^[A-Za-z0-9-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Please enter a valid HolidayName"
    ],

    occuranceData: [
      { display_name: "1st", value: "1" },
      { display_name: "2nd", value: "2" },
      { display_name: "3rd", value: "3" },
      { display_name: "4th", value: "4" },
      { display_name: "5th", value: "5" }
    ],
    dayData: [
      { display_name: "Sunday", value: "0" },
      { display_name: "Monday", value: "1" },
      { display_name: "Tuesday", value: "2" },
      { display_name: "Wednesday", value: "3" },
      { display_name: "Thursday", value: "4" },
      { display_name: "Friday", value: "5" },
      { display_name: "Saturday", value: "6" }
    ],
    holidayExportToCsv: [],
    half: [
      { display_name: "First", value: "1" },
      { display_name: "Second", value: "2" }
    ],
    holidays_fields: {
      SetName: "name",
      HolidayName: "holidayname",
      Date: "allowedDates",
      FullDayHoliday: "isFullDayHoliday",
      FirstHalfHoliday: "isFirstHalfHoliday",
      SecondHalfHoliday: "isSecondHalfHoliday"
    },
    selectedHolidays: [],
    halfModel: "",

    occurance: [],
    setLoading: true,
    day: [],
    holidayName: "",
    switch1: false,
    switch2: false,
    dates: [new Date().toISOString().substr(0, 10)],
    menu: false,
    dialog: false,
    search: "",
    companyId: "",
    modal2: false,
    modal1: false,

    headers: [
      {
        text: "Set Name",
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: "Holiday Name",
        align: "left",
        value: "name",
        sortable: false
      },
      {
        text: "Edit",
        align: "left",
        value: "edit",
        sortable: false
      },
      {
        text: "Delete",
        align: "left",
        value: "delete",
        sortable: false
      }
    ],
    holidays: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      companyId: ""
    },
    defaultItem: {
      name: "",
      companyId: ""
    },
    // selectedHolidaysId: []
  }),
  computed: {
    
    searchContents() {
      const self = this;
      self.renderComponent = false;
      _.each(self.holidayContents, f => {
        var re = new RegExp(self.search.toLowerCase(), "g");

        if (f.title.toLowerCase().match(re)) {
          f.visible = true;
        } else if (self.search == "") {
          f.visible = true;
        } else {
          f.visible = false;
        }

        self.$nextTick(() => {
          self.renderComponent = true;
        });
      });
    },
    formTitle() {
      return this.editedIndex === -1 ? "New" : "Edit";
    },

    pagination: {
      get: function() {
        if (this.$store.getters.pagination) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        }
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.getHolidayData();
    this.editedItem.companyId = this.$store.state.userDetails.companyId;
    this.defaultItem.companyId = this.$store.state.userDetails.companyId;
  },
  methods: {
    exportInCSV() {
     
      var csv = Papa.unparse(this.holidayExportToCsv);

      if (this.$mq != 'mobile') {

        try {
          var csvData = new Blob([csv], {
            type: 'text/csv;charset=utf-8;'
          });

          var csvURL = null;
          if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, 'download.csv');
          } else {
            csvURL = window.URL.createObjectURL(csvData);
          }

          var tempLink = document.createElement('a');
          tempLink.href = csvURL;
          tempLink.setAttribute('download', 'download.csv');
          tempLink.click();

        } catch(e) {console.log(e)}

      } else {

        window.resolveLocalFileSystemURL( cordova.file.cacheDirectory, function(dir) {
          console.log('dir', dir);
          dir.getFile(
            'export-holiday-'+new Date().getTime()+'.csv',
            {
              create: true
            },
            function(file) {
              console.log('file', file);
              
              var logOb = file;

              function writeLog(str) {
                if (!logOb) return;
                logOb.createWriter(
                  function(fileWriter) {

                    fileWriter.seek(fileWriter.length)
                    var blob = new Blob([str], {
                      type: 'text/csv;charset=utf-8;'
                    });
                    fileWriter.write(blob);
                    window.plugins.socialsharing.share(null, null, logOb.nativeURL, null);
                  },
                  () => {
                    this.$swal({type: "error", text: 'Something went wrong'});
                  }
                );
              }

              writeLog(csv);
            }
          );
        });
      }
    },
   
    BulkDeleteIds(ids) {
      this.selectedHolidaysId = ids;
    },
    //bulk delete holidays
    bulkDeleteHolidays() {
      const self = this

      if (this.selectedHolidaysId.length < 1) {
        this.$swal({ type: "warning", text: "There is no selected members" });
        return;
      }

      self.$swal({
        text: `Do you want to continue`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          self.preLoader = true
          const postObj = {
            ids: self.selectedHolidaysId
          };

          self.$http.post(`${self.$store.state.endpoint}holidaySets/bulk/delete`, postObj).then(
            response => {
              self.selectedHolidaysId = [];
              self.selectAllData = false;
              self.getHolidayData();
              self.$swal({ type: "success", text: "Successfully deleted" });
            },
            error => {
              self.preLoader = false
              self.preLoader = false
              self.$swal({ type: "error", text: "Something went wrong" });
            }
          );
        }
      })
      self.preLoader = false
    },

    selectAll() {
      this.renderComponent = false;
      this.selectAllData = true;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },

    splitToComma(v) {
      return v.join(", ");
    },

    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },

    // getHalfName(value){

    //   var halfData = this.half

    //     for(var o in halfData){
    //       for(var m in value){
    //         if (halfData[o].value == value[m]){
    //         
    //           return halfData[o].display_name
    //         }
    //     }
    //   }

    // },
    getHalfDisplayName(value) {
   
      const halfName = [];

      const halfData = this.half;

      for (const o in halfData) {
        for (const m in value) {
          if (halfData[o].value == value[m]) {
            halfName.push(halfData[o].display_name);
          }
        }
      }

      return halfName;
    },
    BulkDeleteIds(ids) {
      this.selectedHolidaysId = ids;
    },
    getHolidayData() {
      this.loading.holidayOption = true;

      this.holidays = [];
      // this.setLoading = true

      this.$http
        .get(
          `${this.$store.state.endpoint}holidaySets?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          this.CheckOut = this.holidays;
          this.loading.holidayOption = false;
          this.holidays = response.body;
          var response = response.body;

          this.holidayExportToCsv = [];
          this.holidayContents = [];
          for (const x in response) {
            // export to excel format
            const holidayDetails = response[x].holidays;
            response[x].holidayname = [];
            response[x].allowedDates = [];
            for (const y in holidayDetails) {
              // Holiday Name
              response[x].holidayname.push(`${holidayDetails[y].name.toString()}`);
              // Dates
              const allowedDatesVar = holidayDetails[y].dates;
              for (const m in allowedDatesVar) {
                response[x].allowedDates += moment(allowedDatesVar[m]).format("DD-MM-YYYY") + ", ";
              }

              // Full Day off or half day off
              response[x].isFullDayHoliday = "No";
              response[x].isFirstHalfHoliday = "No";
              response[x].isSecondHalfHoliday = "No";

              if (holidayDetails[y].halfDay) {
                if (holidayDetails[y].halfDayHalf == "1") {
                  response[x].isFirstHalfHoliday = "Yes";
                }
                if (holidayDetails[y].halfDayHalf == "2") {
                  response[x].isSecondHalfHoliday = "Yes";
                }
              } else {
                response[x].isFullDayHoliday = "Yes";
              }
            }

            // export to csv format
            var holidays = response[x].holidays;
            
            if (response[x].holidays.length > 1) {
              for (var y in holidays) {
                var holidayPayload = {};
                holidayPayload.SetName = response[x].name;
                holidayPayload.HolidayName = holidays[y].name;

                if (holidays[y].dates.length > 1) {
                  holidayPayload.Date = _.join(
                    _.map(holidays[y].dates, date => {
                      return date;
                    }),
                    ","
                  );
                } else {
                  holidayPayload.Date = _.map(holidays[y].dates, date => {
                    return date;
                  });
                }

                holidayPayload.FullDayHoliday = "";
                holidayPayload.FirstHalfHoliday = "";
                holidayPayload.SecondHalfHoliday = "";

                if (holidays[y].halfDay) {
                  if (holidays[y].halfDayHalf == 1) {
                    holidayPayload.FirstHalfHoliday = "Yes";
                  }

                  if (holidays[y].halfDayHalf == 2) {
                    holidayPayload.SecondHalfHoliday = "Yes";
                  }
                } else {
                  holidayPayload.FullDayHoliday = "Yes";
                }
               
                this.holidayExportToCsv.push(holidayPayload);
              }
            } else {
              
              var holidayPayload = {};
              holidayPayload.SetName = response[x].name;
              holidayPayload.HolidayName = response[x].holidays[0].name;
              if (response[x].holidays[0].dates.length > 1) {
                holidayPayload.Date = _.join(
                  _.map(response[x].holidays[0].dates, date => {
                    return date;
                  }),
                  ","
                );
              } else {
                holidayPayload.Date = _.map(response[x].holidays[0].dates, date => {
                  return date;
                });
              }

              holidayPayload.FullDayHoliday = "";
              holidayPayload.FirstHalfHoliday = "";
              holidayPayload.SecondHalfHoliday = "";

              if (response[x].holidays[0].halfDay) {
                if (response[x].holidays[0].halfDayHalf == 1) {
                  holidayPayload.FirstHalfHoliday = "Yes";
                }

                if (response[x].holidays[0].halfDayHalf == 2) {
                  holidayPayload.SecondHalfHoliday = "Yes";
                }
              } else {
                holidayPayload.FullDayHoliday = "Yes";
              }
              this.holidayExportToCsv.push(holidayPayload);
            }

            // title
            response[x].title = response[x].name;
            response[x].visible = true;
            response[x].permissionType = "modifyHolidays";

            response[x].contents = {
              Name: _.join(response[x].holidayname, ", "),
              Date: response[x].allowedDates
            };

            this.holidayContents.push(response[x]);
          }

          this.preLoader = false
          this.isClicked = false

          this.setLoading = false;
        })
        .catch(error => {
        
          this.preLoader = false
          this.isClicked = false
          this.loading.holidayOption = false;
          this.networkError.holidayOption = true;
        });
    },

    addHoliday() {
      if (this.holidayName == "" || this.dates == "") {
        this.$swal({
          type: "error",
          text: "Please fill the required fields"
        });
        return;
      }

      if (this.$refs.holidayNameRules.validate() == false) {
        this.$swal({
          type: "error",
          text: "Please enter a valid HolidayName"
        });
      } else {
        const halfDay = this.switch2;
        if (halfDay) {
          var halfDayHalf = this.halfModel;
          if (this.half.display_name == "First") {
            halfDayHalf == "1";
          } else if (this.half.display_name == "Second") {
            halfDayHalf == "2";
          }
        } else {
          halfDayHalf = "0";
        }

        const alreadySelectedDates = _.flattenDeep(
          _.map(this.selectedHolidays, h => _.map(h.dates, d => d))
        );

        const currentSelectedDates = this.dates;

        for (const x in currentSelectedDates) {
          for (const y in alreadySelectedDates) {
            if (moment(currentSelectedDates[x]).isSame(moment(alreadySelectedDates[y]))) {
              this.$swal({
                type: "error",
                title: "Error",
                text: "These dates already have a holiday defined"
              });
              return;
            }
          }
        }

        this.selectedHolidays.push({
          name: this.holidayName,
          dates: this.dates,
          halfDay,
          halfDayHalf
        })

        this.holidayName = "";
        this.dates = [];
        // reset validations
        this.$refs.holidayNameRules.resetValidation();
       
      }
    },
    removeHoliday(item) {
      this.selectedHolidays.splice(item, 1);
    },

    editItem(item) {
     
      this.editedIndex = this.holidays.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.selectedHolidays = this.editedItem.holidays;
      this.getAssignes(this.editedItem.id)
      this.dialog = true;
    },

    getAssignes(id){
     
      this.assignes = []
      this.loader = true
      this.$http.get(`${this.$store.state.endpoint}accounts?filter[where][companyId]=${this.$store.getters.userDetails.companyId}&filter[where][allowedHolidaySets]=${id}`)
      .then((response) => {
       
        this.assignes = response.body
        this.loader = false
      })
      .catch((err) => {
        this.loader = false
      
      })
    },

    deleteItem(item) {
     
      const self = this
      self.$swal({
        text: `Are you sure you want to delete ${item.name}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          const itemObj = item.id;
          //  const index = self.holidays.indexOf(item)
          // write item delete code
          self.preLoader = true
          self.$http.delete(`${self.$store.state.endpoint}holidaySets/${itemObj}`).then(
            response => {
             
              self.getHolidayData();
            },
            error => {
             
              // error callback
              self.preLoader = false
              self.$swal({type: "error", text: "Something went wrong. Try again later"})
            }
          );
        }
      })
      
    },
    close() {
      this.dialog = false;
      // clearing all the fields
      this.selectedHolidays = []; // addedSets
      this.editedItem.name = ""; // holidaySetName
      this.holidayName = ""; // holidayName
      this.dates = []; // dates
      this.halfModel = ""; // halfDay
      this.isClicked = false
      
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
      
    },
    save() {
      // initiate
      this.preLoader = true
      this.isClicked = true
      
      const holidays = this.selectedHolidays
      const itemObj = this.editedItem;

      if (itemObj.name == "") {
        this.$swal({
          type: "error",
          text: "Please provide a HolidaySet name"
        });
        this.preLoader = false
        this.isClicked = false
        return;
      }

      if (this.selectedHolidays == "") {
        this.$swal({
          type: "error",
          text: "Enter a holiday name and assign a date"
        })
        this.preLoader = false
        this.isClicked = false
        return;
      }

      if (this.editedIndex > -1) {

        const updateObj = {
          name: itemObj.name,
          companyId: itemObj.companyId,
          holidays
        };

        this.$http.patch(`${this.$store.state.endpoint}holidaySets/${itemObj.id}`, updateObj).then(
          response => {
            
            this.selectedHolidays = [];
            // reset validation
            this.$refs.holidayNameRules.resetValidation()
            this.$refs.holidaySetName.resetValidation()

            this.getHolidayData();
          },
          error => {
            this.preLoader = false
            this.isClicked = false
            this.$swal({
              type: "error",
              title: "Oops",
              text: "Something went wrong, try again later"
            });
          }
        );
      } else {
        const self = this;
        const insertObj = {
          name: itemObj.name,
          companyId: itemObj.companyId,
          holidays
        }

        // validation for SetName
        for (const x in self.holidays) {
          if (insertObj.name.toLowerCase() == self.holidays[x].name.toLowerCase()) {
            self.$swal({ type: "warning", text: "Enter a different set name" });
            self.preLoader = false
            self.isClicked = false
            return;
          }
        }

        this.$http.post(`${this.$store.state.endpoint}holidaySets`, insertObj).then(
          response => {
            self.selectedHolidays = []
            self.getHolidayData()
            // reset validation
            self.$refs.holidayNameRules.resetValidation()
            self.$refs.holidaySetName.resetValidation()
          },
          error => {
            // error callback
            self.preLoader = false
            self.isClicked = false
            self.$swal({
              type: "error",
              title: "Oops",
              text: "Something went wrong, try again later"
            });
          }
        );
      }
      console.log("-- reached --")
      this.close();
    }
    
  }
};
</script>
<style scoped></style>
